// 缓存库存数据
const inventoryCache = {};
document.querySelectorAll('.variant-inventory').forEach((element) => {
    const size = element.dataset.size;
    inventoryCache[size] = element;
});

// 封装更新库存显示的函数
function updateInventoryDisplay() {
    // 获取当前选中的 size 信息
    const sizeElement = document.querySelector('variant-radios fieldset legend span');
    const selectedSize = sizeElement ? sizeElement.textContent : null;

    // 隐藏所有 variant-inventory 元素
    Object.values(inventoryCache).forEach((element) => {
        element.style.display = 'none';
    });

    // 如果 sizeElement 不存在，默认显示所有库存信息
    if (!sizeElement) {
        Object.values(inventoryCache).forEach((element) => {
            element.style.display = 'flex';
        });
        return;
    }

    // 显示匹配的 variant-inventory 元素
    if (selectedSize && inventoryCache[selectedSize]) {
        inventoryCache[selectedSize].style.display = 'flex';
    }
}

// 使用事件委托监听 change 事件
function bindChangeEvent() {
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
        variantRadios.addEventListener('change', function (event) {
            if (event.target.matches('input[type="radio"]')) {
                updateInventoryDisplay();
            }
        });
    }
}

// 使用 MutationObserver 监听 DOM 变化
function observeVariantRadios() {
    const targetNode = document.querySelector('variant-radios');
    if (targetNode) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // 重新绑定事件并更新显示
                    bindChangeEvent();
                    updateInventoryDisplay();
                }
            }
        });
        observer.observe(targetNode, {childList: true, subtree: true});
    }
}

// 页面加载时初始化
document.addEventListener('DOMContentLoaded', function () {
    bindChangeEvent();
    updateInventoryDisplay();
    observeVariantRadios();
});

// Multi Links
document.addEventListener('DOMContentLoaded', function () {
    // 查找具有 multi-link-available 类的元素
    var availableLink = document.querySelector('.multi-link-available');
    if (availableLink) {
        // 提取 multi-link-available 下 span 的文本内容
        var availableText = availableLink.querySelector('.text').textContent;
        // 查找 multi-link-active 下的 span 元素
        var activeSpan = document.querySelector('.multi-link-active span');
        if (activeSpan) {
            // 将提取的文本内容更新到 multi-link-active 下的 span 中
            activeSpan.textContent = availableText;
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const guideLabel = document.querySelector('.guide-label');
    const wattGuide = document.querySelector('.product-watt_guide');
    const closeBtn = document.querySelector('.product-watt_guide .close');

    // 打开 Watt Guide
    guideLabel.addEventListener('click', function () {
        wattGuide.classList.add('active');
        document.body.style.overflow = 'hidden'; // 防止背景滚动
    });

    // 关闭 Watt Guide
    closeBtn.addEventListener('click', function () {
        wattGuide.classList.remove('active');
        document.body.style.overflow = ''; // 恢复滚动
    });

    // 点击背景关闭
    wattGuide.addEventListener('click', function (e) {
        if (e.target === wattGuide) {
            wattGuide.classList.remove('active');
            document.body.style.overflow = '';
        }
    });

    // ESC键关闭
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wattGuide.classList.contains('active')) {
            wattGuide.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const fullList = document.getElementById("five-point-list");
    // const fullList = document.querySelectorAll("GGJIA-specification-container");
    const seeMoreBtn = document.getElementById("see-more-btn");
    const items = fullList.getElementsByTagName("li");
    
    // 初始状态：只显示前两项
    if (items.length > 2) {
      for (let i = 1; i < items.length; i++) {
        items[i].style.display = "none";
      }
      seeMoreBtn.style.display = "block"; // 确保按钮显示
    } else {
      seeMoreBtn.style.display = "none"; // 如果不足两项，隐藏按钮
    }

    // 添加点击事件
    seeMoreBtn.addEventListener("click", function () {
      // 切换隐藏项的显示状态
      for (let i = 2; i < items.length; i++) {
        if (items[i].style.display === "none") {
          items[i].style.display = "list-item";
        } else {
          items[i].style.display = "none";
        }
      }

      // 切换按钮文本
      if (seeMoreBtn.textContent === "See less") {
        seeMoreBtn.textContent = "See more";
        seeMoreBtn.classList.add("see-more");
      } else {
        seeMoreBtn.textContent = "See less";
        seeMoreBtn.classList.remove("see-more");
      }
    });
  });